import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useIntl } from 'react-intl';

interface ScriptTagsWarningProps {
  template: string;
}

/**
 * ScriptTagsWarning Component
 *
 * Displays a warning when script tags are detected in a template.
 * Script tags are automatically removed during template processing for security reasons.
 *
 * @param {string} template - The template string to check for script tags
 */
export const ScriptTagsWarning = ({ template }: ScriptTagsWarningProps) => {
  const intl = useIntl();

  // Check if template contains script tags (case-insensitive)
  // Matches both complete <script>...</script> tags and opened <script tags
  const hasScriptTags =
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi.test(template) ||
    /<script\b[^>]*>/gi.test(template);

  if (!hasScriptTags) {
    return null;
  }

  return (
    <Alert
      icon={<IconAlertTriangle size={16} />}
      title={intl.formatMessage({ id: 'warning' })}
      color="yellow"
    >
      {intl.formatMessage({ id: 'scriptTagsWarning' })}
    </Alert>
  );
};
